export const aboutFeatures = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: 'Reliable Cleaning Services',
    description:
      'Count on us for consistent, dependable cleaning every time. We show up on schedule and deliver the same high standard of cleanliness you expect.',
  },
  {
    id: 2,
    icon: 'ri-user-star-line',
    title: 'Trained Professional Team',
    description:
      'Our staff undergoes rigorous training and background checks. You can trust our crew inside your home or office.',
  },
  {
    id: 3,
    icon: 'ri-calendar-schedule-line',
    title: 'Flexible Scheduling',
    description:
      'Book us when it suits you — mornings, evenings, weekends, or last-minute emergencies. We adapt to your calendar.',
  },
  {
    id: 4,
    icon: 'ri-repeat-line',
    title: 'One-Time or Recurring Contracts',
    description:
      'Choose a single deep clean, weekly maintenance, or a custom plan. No long-term commitment required.',
  },
];

export const aboutStats = [
  { value: '500+', label: 'Happy Clients' },
  { value: '10+', label: 'Years Experience' },
  { value: '50+', label: 'Trained Staff' },
  { value: '98%', label: 'Satisfaction Rate' },
];